<template>
  <div v-if="block">
    <menu-content-container
      :chip="blockName + ' ' + $t(`api_block.properties`)"
      chip-secondary
      :border-bottom="false"
    >
    </menu-content-container>
    <settings-form :block="block"></settings-form>
  </div>
</template>

<script lang="ts" setup>
  import settingsForm from "./APIBlock/settingsForm.vue";

  import { TopolFeedBlock } from "@/schemas/template/blocks/feedBlockSchema";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { useApiBlocksStore } from "@/stores/apiBlocks";
  import { computed } from "vue";

  const mjmlStore = useMjmlStore();
  const apiBlocksStore = useApiBlocksStore();

  const block = computed(() => {
    return mjmlStore.getActiveBlock as TopolFeedBlock;
  });

  const blockName = computed(() => {
    if (block.value && block.value.blockName) {
      return apiBlocksStore.blocks.get(block.value.blockName)?.name;
    }
    return "";
  });
</script>
